export default __webpack_public_path__ + "static/media/KOD0015-min.30aad47e.webp";